import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { RegistrationMode } from "@/shared/domain/mcp";

import { adminMcpServersQueryKey } from "./useAdminMcpServers";

export interface AdminRegisterMcpServerRequest {
  registration_mode: RegistrationMode;
  server_url: string;
  display_name: string;
  oauth_issuer_url: string;
  authorization_endpoint?: string;
  token_endpoint?: string;
  client_id?: string;
  client_secret?: string;
  scopes: string[];
  revocation_endpoint?: string;
  extra_auth_params?: Record<string, string>;
  org_ids: string[];
}

export function useAdminRegisterMcpServer() {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: AdminRegisterMcpServerRequest) =>
      mcpRegistryService.adminRegisterServer(request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminMcpServersQueryKey,
      });
    },
  });
}
